import DownloadAppButton from 'src/components/design-system/DownloadAppButton';
import { useTranslations } from 'next-intl';
import Container from '../Container';

export default function DownloadBanner() {
  const t = useTranslations('bar');

  return (
    <div className="text-center bg-greyscale-pink rounded-md py-6 px-3 space-y-4">
      <h2 className="text-greyscale-title mb-0 font-bold text-2xl">
        {t('downloadBanner.title')}
      </h2>
      <p className="text-greyscale-body text-base font-medium">
        {t('downloadBanner.text')}
      </p>
      <div className="flex justify-center">
        <DownloadAppButton />
      </div>
    </div>
  );
}
